.root {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: var(--m-sp-sm);
	padding: var(--m-sp-sm);
	@apply --mx-bg(var(--m-surface-secondary-bg));
	@apply --mx-fg(var(--m-surface-secondary-fg));
}

.content {
	flex: 1;
	@apply --mx-prose-secondary;
}
